// Restaurant view state
import gql from 'graphql-tag';
import { graphql } from '../../utils/fetch';

const RESTAURANT_FRAGMENT =
  ` fragment restaurantFields on Restaurant {
      id
      name
      access
      categories
      link
      description
      address {
        street
        city
        state
        country
      }
    }
  `;

const state = {
  // The restaurant to view
  restaurant: null,
};

const getters = {
  restaurant(s) {
    return s.restaurant;
  },
};

const mutations = {
  restaurant(s, r) {
    s.restaurant = r;
  },
};

const actions = {
  fetchRestaurant({ commit }, id) {
    return graphql.query({
      query: gql`query Restaurant($id: ID!) {
        restaurantById(id: $id) {
          ...restaurantFields
        }
      }
      ${RESTAURANT_FRAGMENT}`,
      variables: {
        id,
      },
    })
    .then((response) => {
      if (!response.data.restaurantById) {
        commit('restaurant', null);
        throw new Error('Unknown restaurant');
      }
      commit('restaurant', response.data.restaurantById);
      return response.data.restaurantById;
    })
    .catch((err) => {
      commit('restaurant', null);
      throw err;
    });
  },

  saveRestaurant({ commit }, restaurant) {
    return graphql.mutate({
      mutation: gql`mutation Restaurant($restaurant: RestaurantInput!) {
        createRestaurant(restaurant: $restaurant) {
          id
        },
      }`,
      variables: {
        restaurant,
      },
    })
    .then((response) => {
      commit('notify', {
        message: 'Restaurant created',
        type: 'is-success',
      }, { root: true });

      // TODO knowledge of 'foodItems' query should not be here
      graphql.localExtensions.invalidateStoreQuery('foodItems');
      return response.data.createRestaurant.id;
    });
  },

  updateRestaurant({ commit }, { id, restaurant }) {
    return graphql.mutate({
      mutation: gql`mutation Restaurant($id: ID!, $restaurant: RestaurantInput!) {
        updateRestaurant(id: $id, restaurant: $restaurant) {
          ...restaurantFields
        }
      }
      ${RESTAURANT_FRAGMENT}`,
      variables: {
        id,
        restaurant,
      },
    })
    .then((response) => {
      if (!response.data.updateRestaurant) {
        commit('restaurant', null);
        throw new Error('Unknown restaurant');
      }

      commit('notify', {
        message: 'Restaurant updated',
        type: 'is-success',
      }, { root: true });

      // TODO knowledge of 'foodItems' query should not be here
      graphql.localExtensions.invalidateStoreQuery('foodItems');
      return response.data.updateRestaurant;
    })
    .catch((err) => {
      commit('restaurant', null);
      throw err;
    });
  },

  deleteRestaurant({ commit }, id) {
    return graphql.mutate({
      mutation: gql`mutation Restaurant($id: ID!) {
        deleteRestaurant(id: $id) {
          ...restaurantFields
        }
      }
      ${RESTAURANT_FRAGMENT}`,
      variables: {
        id,
      },
    })
    .then((response) => {
      if (!response.data.deleteRestaurant) {
        throw new Error('Unknown restaurant');
      }

      commit('restaurant', null);

      commit('notify', {
        message: 'Restaurant deleted',
        type: 'is-success',
      }, { root: true });

      // TODO knowledge of 'foodItems' query should not be here
      graphql.localExtensions.invalidateStoreQuery('foodItems');
    })
    .catch((err) => {
      throw err;
    });
  },
};

export default {
  namespaced: true,

  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/restaurant.js